import { useState, useEffect } from "react";
import api from "../services/api";

const defaultForm = {
  nome: "", cpf: "", email: "",
  salario_base: 1838.41, qtd_trienios: 0,
  valor_unitario_trienio: 124.25,
  plano_saude: 1243.12, vale_alimentacao_dia: 38.32,
  // parametros individuais (null = herda global)
  taxa_impostos: null, taxa_desp_comercial: null, taxa_desp_administrativa: null,
  taxa_socios: null, taxa_lucro_esperado: null, taxa_fgts: null,
  limite_inss: null, limite_repasse: null, percentual_repasse_resultado_positivo: null,
  auxilio_transporte: 0, despesa_extra_1: 0, despesa_extra_2: 0,
  premio_adicional_ativo: false, premio_adicional_percentual: 4,
};

export default function Vendedores() {
  const [vendedores, setVendedores] = useState([]);
  const [form, setForm] = useState(defaultForm);
  const [editing, setEditing] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState("");
  const [showParams, setShowParams] = useState(false);

  const load = () => api.get("/vendedores").then(({ data }) => setVendedores(data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault(); setError("");
    const payload = {
      ...form,
      salario_base: parseFloat(form.salario_base),
      qtd_trienios: parseInt(form.qtd_trienios),
      valor_unitario_trienio: parseFloat(form.valor_unitario_trienio),
      plano_saude: parseFloat(form.plano_saude),
      vale_alimentacao_dia: parseFloat(form.vale_alimentacao_dia),
    };
    try {
      if (editing) await api.put("/vendedores/" + editing, payload);
      else await api.post("/vendedores", payload);
      setShowModal(false); setEditing(null); setForm(defaultForm); load();
    } catch (err) {
      const msg = err.response?.data?.detail || "Erro ao salvar vendedor.";
      setError(typeof msg === "string" ? msg : JSON.stringify(msg));
    }
  };

  const toggleStatus = async (id) => {
    try { await api.patch("/vendedores/" + id + "/status"); load(); }
    catch (err) { alert(err.response?.data?.detail || "Erro ao alterar status"); }
  };

  const deleteVendedor = async (v) => {
    if (!window.confirm("Excluir \"" + v.nome + "\" e TODOS os calculos vinculados?\n\nEsta acao e irreversivel.")) return;
    try { await api.delete("/vendedores/" + v.id); load(); }
    catch (err) { alert(err.response?.data?.detail || "Erro ao excluir vendedor"); }
  };

  const openEdit = (v) => {
    setForm({ nome: v.nome, cpf: v.cpf || "", email: v.email || "",
      salario_base: v.salario_base, qtd_trienios: v.qtd_trienios,
      valor_unitario_trienio: v.valor_unitario_trienio,
      plano_saude: v.plano_saude, vale_alimentacao_dia: v.vale_alimentacao_dia,
      taxa_impostos: v.taxa_impostos ?? null,
      taxa_desp_comercial: v.taxa_desp_comercial ?? null,
      taxa_desp_administrativa: v.taxa_desp_administrativa ?? null,
      taxa_socios: v.taxa_socios ?? null,
      taxa_lucro_esperado: v.taxa_lucro_esperado ?? null,
      taxa_fgts: v.taxa_fgts ?? null,
      limite_inss: v.limite_inss ?? null,
      limite_repasse: v.limite_repasse ?? null,
      percentual_repasse_resultado_positivo: v.percentual_repasse_resultado_positivo ?? null,
      auxilio_transporte: v.auxilio_transporte ?? 0,
      despesa_extra_1: v.despesa_extra_1 ?? 0,
      despesa_extra_2: v.despesa_extra_2 ?? 0,
      premio_adicional_ativo: v.premio_adicional_ativo ?? false,
      premio_adicional_percentual: v.premio_adicional_percentual ?? 4,
    });
    setEditing(v.id); setShowModal(true); setError("");
  };

  return (
    <div>
      <div className="d-flex justify-content-between mb-3">
        <h4 className="fw-bold mb-0">Vendedores</h4>
        <button className="btn btn-primary" onClick={() => { setForm(defaultForm); setEditing(null); setShowModal(true); setError(""); }}>
          + Novo Vendedor
        </button>
      </div>
      <div className="table-responsive">
        <table className="table table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>Nome</th><th>CPF</th><th>Salario Base</th><th>Trienios</th>
              <th>Plano Saude</th><th>Vale Alim./dia</th><th>Status</th><th>Acoes</th>
            </tr>
          </thead>
          <tbody>
            {vendedores.map((v) => (
              <tr key={v.id}>
                <td className="fw-semibold">{v.nome}</td>
                <td>{v.cpf || "—"}</td>
                <td>R$ {v.salario_base?.toFixed(2)}</td>
                <td>{v.qtd_trienios} x R${v.valor_unitario_trienio?.toFixed(2)} = R${v.trienio_total?.toFixed(2)}</td>
                <td>R$ {v.plano_saude?.toFixed(2)}</td>
                <td>R$ {v.vale_alimentacao_dia?.toFixed(2)}</td>
                <td>
                  <span className={"badge " + (v.is_active ? "bg-success" : "bg-secondary")}>
                    {v.is_active ? "Ativo" : "Inativo"}
                  </span>
                </td>
                <td>
                  <button className="btn btn-sm btn-outline-primary me-1" onClick={() => openEdit(v)}>Editar</button>
                  <button className={"btn btn-sm me-1 " + (v.is_active ? "btn-outline-warning" : "btn-outline-success")}
                    onClick={() => toggleStatus(v.id)}>
                    {v.is_active ? "Inativar" : "Ativar"}
                  </button>
                  <button className="btn btn-sm btn-outline-danger" title="Excluir vendedor e historico"
                    onClick={() => deleteVendedor(v)}>🗑️ Excluir</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5>{editing ? "Editar Vendedor" : "Novo Vendedor"}</h5>
                <button className="btn-close" onClick={() => setShowModal(false)} />
              </div>
              <form onSubmit={save}>
                <div className="modal-body row g-3">
                  {error && <div className="col-12"><div className="alert alert-danger py-2">{error}</div></div>}
                  <div className="col-md-4">
                    <label className="form-label">Nome *</label>
                    <input type="text" className="form-control" required
                      value={form.nome} onChange={(e) => setForm({...form, nome: e.target.value})} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">CPF</label>
                    <input type="text" className="form-control"
                      value={form.cpf} onChange={(e) => setForm({...form, cpf: e.target.value})} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">E-mail</label>
                    <input type="email" className="form-control"
                      value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} />
                  </div>
                  {[["salario_base","Salário Fixo (R$)","0.01"],
                    ["qtd_trienios","Qtd. Trienios","1"],
                    ["valor_unitario_trienio","Valor Unit. Trienio (R$)","0.01"],
                    ["plano_saude","Plano de Saude (R$)","0.01"],
                    ["vale_alimentacao_dia","Vale Alim./dia (R$)","0.01"],
                  ].map(([k,l,step]) => (
                    <div key={k} className="col-md-4">
                      <label className="form-label">{l}</label>
                      <input type="number" step={step} className="form-control"
                        value={form[k] ?? ""} onChange={(e) => setForm({...form, [k]: e.target.value})} />
                    </div>
                  ))}

                  {/* Parâmetros individuais */}
                  <div className="col-12 mt-2">
                    <div className="card border-secondary">
                      <div className="card-header d-flex justify-content-between align-items-center py-2"
                        style={{cursor:"pointer"}} onClick={() => setShowParams(v => !v)}>
                        <span className="fw-semibold small">Parâmetros Individuais do Vendedor</span>
                        <span className="text-muted small">{showParams ? "▲ recolher" : "▼ expandir"}</span>
                      </div>
                      {showParams && (
                        <div className="card-body row g-2">
                          <p className="text-muted small mb-1 col-12">
                            Deixe em branco para usar os parâmetros globais do sistema.
                          </p>
                          {[
                            ["taxa_impostos",                       "% Impostos",          "ex: 0.1975 = 19,75%", "0.0001", 0, 1],
                            ["taxa_desp_comercial",                 "% Desp. Comercial",   "ex: 0.077 = 7,7%",   "0.0001", 0, 1],
                            ["taxa_desp_administrativa",            "% Desp. Administrativa","ex: 0.2499 = 24,99%","0.0001", 0, 1],
                            ["taxa_socios",                        "% Sócios (info)",      "ex: 0.1863 = 18,63%","0.0001", 0, 1],
                            ["taxa_lucro_esperado",                 "% Lucro Esperado",    "ex: 0.05 = 5%",      "0.0001", 0, 1],
                            ["taxa_fgts",                          "% FGTS",              "ex: 0.08 = 8%",      "0.0001", 0, 1],
                            ["limite_inss",                        "Limite INSS (R$)",     "ex: 8000",           "0.01",   0, null],
                            ["limite_repasse",                     "Limite Repasse (%)",   "ex: 100",            "0.01",   0, 100],
                            ["percentual_repasse_resultado_positivo","% Repasse Resultado Positivo","ex: 0.40 = 40%","0.0001",0,1],
                          ].map(([k, label, placeholder, step, min, max]) => (
                            <div key={k} className="col-md-4">
                              <label className="form-label small mb-1">{label}</label>
                              <input type="number" step={step} min={min} max={max ?? undefined}
                                className="form-control form-control-sm" placeholder={placeholder}
                                value={form[k] ?? ""}
                                onChange={(e) => setForm({...form, [k]: e.target.value === "" ? null : parseFloat(e.target.value)})} />
                            </div>
                          ))}
                          <div className="col-12"><hr className="my-1"/><p className="small fw-semibold mb-1">Despesas Fixas Adicionais (R$)</p></div>
                          {[
                            ["auxilio_transporte","Auxílio Transporte","ex: 200.00","0.01",0,null],
                            ["despesa_extra_1","Despesa Extra 1","ex: 150.00","0.01",0,null],
                            ["despesa_extra_2","Despesa Extra 2","ex: 100.00","0.01",0,null],
                          ].map(([k, label, placeholder, step, min, max]) => (
                            <div key={k} className="col-md-4">
                              <label className="form-label small mb-1">{label}</label>
                              <input type="number" step={step} min={min} max={max ?? undefined}
                                className="form-control form-control-sm" placeholder={placeholder}
                                value={form[k] ?? ""}
                                onChange={(e) => setForm({...form, [k]: e.target.value === "" ? null : parseFloat(e.target.value)})} />
                            </div>
                          ))}
                          <div className="col-12"><hr className="my-1"/><p className="small fw-semibold mb-1">Prêmio Adicional (bônus sobre o teto de repasse)</p></div>
                          <div className="col-md-4">
                            <div className="form-check form-switch mt-4">
                              <input className="form-check-input" type="checkbox" role="switch"
                                id="swPremioAdic" checked={!!form.premio_adicional_ativo}
                                onChange={(e) => setForm({...form, premio_adicional_ativo: e.target.checked})} />
                              <label className="form-check-label small" htmlFor="swPremioAdic">
                                {form.premio_adicional_ativo ? "Ativo" : "Desativado"}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label className="form-label small mb-1">% sobre a Produção</label>
                            <input type="number" step="0.01" min={0} max={100}
                              className="form-control form-control-sm" placeholder="ex: 4.00"
                              disabled={!form.premio_adicional_ativo}
                              value={form.premio_adicional_percentual ?? ""}
                              onChange={(e) => setForm({...form, premio_adicional_percentual: e.target.value === "" ? null : parseFloat(e.target.value)})} />
                          </div>
                          <div className="col-12">
                            <p className="small text-muted mb-0">
                              Pago depois que o teto de repasse é atingido e antes de sobrar resultado para a empresa.
                              Limitado ao resultado disponível — nunca gera prejuízo.
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
                  <button type="submit" className="btn btn-primary">Salvar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
